import { render, staticRenderFns } from "./EmergencyDialog.vue?vue&type=template&id=06ec41ba&"
import script from "./EmergencyDialog.vue?vue&type=script&lang=js&"
export * from "./EmergencyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports